// assets/js/controllers/tags_schedule_controller.ts

import { Controller } from '@hotwired/stimulus';

interface TomSelectItem {
    value: string;
    text: string;
}

export default class extends Controller<HTMLSelectElement> {

    connect(): void {

        this.element.addEventListener('change', () => {

            const tomSelect = (this.element as any).tomselect;

            if (!tomSelect) {
                return;
            }

            const selectedValues: string[] = tomSelect.items;

            const grouped: Record<string, string> = {};

            const finalValues: string[] = [];

            selectedValues.forEach((value: string) => {

                const option = tomSelect.options[value];

                if (!option) {
                    return;
                }

                const text: string = option.text;

                const match = text.match(/^\[(.*?)\]/);

                // tags normales
                if (!match) {
                    finalValues.push(value);
                    return;
                }

                const group = match[1];

                // controlar solo días
                if (
                    group !== 'VIERNES' &&
                    group !== 'SABADO' &&
                    group !== 'DOMINGO'
                ) {
                    finalValues.push(value);
                    return;
                }

                // reemplaza el anterior
                grouped[group] = value;
            });

            Object.values(grouped).forEach((value: string) => {
                finalValues.push(value);
            });

            tomSelect.setValue(finalValues, true);
        });
    }
}
